import apiClient from "@/api/client";

export interface HelperChatRequest {
  message: string;
  page?: string;
  tenant_slug?: string;
  conversation_id?: string;
}

export interface HelperChatResponse {
  answer: string;
  conversation_id: string | null;
}

export async function helperChat(
  payload: HelperChatRequest,
): Promise<HelperChatResponse> {
  const { data } = await apiClient.post<HelperChatResponse>(
    "/helper/chat",
    payload,
  );
  return data;
}
